
return _$browser_12;

});


// WEBPACK FOOTER //
// node_modules/browser-pack-flat/_postlude